export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/One-635a492d0b64f53be39e1cab9c120f89.svg";